// Este archivo es generado automáticamente por version-copy.js
// NO EDITAR MANUALMENTE - Se sobrescribe en cada build
export const VERSION = '1.11.8';
